import { MutationTree } from "vuex";
import { IFilterWrapperState } from "./filter-wrapper-states.store";
import store from './filter-wrapper-types.store';

export const mutations: MutationTree<IFilterWrapperState> = {
    [store.Set.PROPERTY_SEARCH_PARAM]: (state: IFilterWrapperState, searchParam: any) => {
        state.propertySearchParam = searchParam;
    },
    [store.Set.PERSON_SEARCH_PARAM]: (state: IFilterWrapperState, searchParam: any) => {
        state.personSearchParam = searchParam;
    },
    [store.Set.DEMAND_SEARCH_PARAM]: (state: IFilterWrapperState, searchParam: any) => {
        state.demandSearchParam = searchParam;
    },
    [store.Set.TASK_SEARCH_PARAM]: (state: IFilterWrapperState, searchParam: any) => {
        state.taskSearchParam = searchParam;
    }
}